import { SH1, colors } from '@zet/design-system'
import { Select } from '@zet/design-system/select'

type Props = {
  label: string
  name: 'brands' | 'paymentStatus' | 'teams'
  selectedValue: string | string[] | null
}

export const TeamEarningsFilterListItem = ({
  label,
  name,
  selectedValue,
}: Props) => {
  return (
    <Select.Option
      name={name}
      selectedValue={selectedValue}
      optionContainerStyle="h-[62] mt-3 w-full justify-center rounded-lg"
      showToggle={true}
      backgroundColor={{
        active: 'bg-primary-10',
        inActive: 'bg-grays-20',
      }}
      iconColor={{
        active: colors.primary[50],
        inActive: colors.grays[60],
      }}
      textColor={{
        active: 'text-grays-80',
        inActive: 'text-grays-60',
      }}
      optionTextStyle="pl-3 pr-4 mr-3"
    >
      <SH1 className="text-grays-80">{label}</SH1>
    </Select.Option>
  )
}
